import { useState } from 'react';
import { Content, Table, Pagination } from 'components';
import { Tag } from 'antd';
import { Link } from 'react-router-dom';
import { stringToMoneyFormat } from 'utils';

const ProductList = ({ productList }) => {
  const [currentPage, setCurrentPage] = useState(1);
  // console.log('productList', productList);

  const getProductStatusColor = (product_status, application_status) => {
    return product_status === 'NORMAL'
      ? '#00BB2A'
      : product_status === 'STOP'
      ? '#EE4700'
      : application_status === 'APPLY'
      ? '#6541F2'
      : '#F9A80C';
  };

  const getProductStatusName = (product_status, application_status) => {
    if (product_status === 'NORMAL') {
      return '판매중';
    } else if (product_status === 'STOP') {
      return '판매중지';
    } else if (application_status === 'APPLY') {
      return '심사중';
    } else if (product_status === 'WAIT') {
      return '판매대기';
    } else {
      return '판매종료';
    }
  };

  const handlePagination = (page) => {
    if (currentPage === page) return;

    setCurrentPage(page);
  };
  return (
    <Content maxWidth={'100%'} borderRadius={4} padding={20}>
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
        검색 결과 총 <span>{productList?.length}</span>건
      </h4>
      <Table
        data={productList?.slice(
          (currentPage - 1) * 10,
          (currentPage - 1) * 10 + 10
        )}
        pagination={false}
        columns={[
          {
            title: '상품 코드',
            key: 'product_code',
          },
          {
            title: '카테고리',
            key: 'product_category',
            render: (item) => {
              return item?.product_category_name;
            },
          },
          {
            title: '상품명',
            key: 'product_name',
            render: (
              item,
              { product_id, product_status, application_status }
            ) => {
              return (
                <p>
                  <Tag
                    style={{
                      borderColor: getProductStatusColor(
                        product_status,
                        application_status
                      ),
                      color: getProductStatusColor(
                        product_status,
                        application_status
                      ),
                    }}
                  >
                    {getProductStatusName(product_status, application_status)}
                  </Tag>
                  <Link to={`/product/list/${product_id}`}>{item}</Link>
                </p>
              );
            },
          },
          {
            title: '판매가',
            key: 'price',
            render: (item) => stringToMoneyFormat(item, '원'),
          },
          {
            title: '수량',
            key: 'num',
            render: (item) => stringToMoneyFormat(item, '개'),
          },
          {
            title: '판매처',
            key: 'shop_information',
            render: (item) => {
              return (
                <Link to={`/brand/list`}>{item?.shop_information_name}</Link>
              );
            },
          },
        ]}
      />
      <Pagination
        current={currentPage}
        pageSize={10}
        total={productList?.length}
        onChange={handlePagination}
        style={{ marginTop: 20 }}
      />
    </Content>
  );
};

export default ProductList;
